import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faFacebookF, 
    faTwitter, 
    faInstagram, 
    faLinkedinIn,
    faApple,
    faGooglePlay
} from '@fortawesome/free-brands-svg-icons';
import './Footer.css';

const Footer = () => {
    const currentYear = new Date().getFullYear();
    
    return (
        <footer className="main-footer">
            <div className="footer-container">
                <div className="footer-section">
                    <h3>Connexierge</h3>
                    <p>Connecting buyers and sellers for a seamless vehicle purchasing experience.</p>
                </div>
                
                <div className="footer-section">
                    <h3>Quick Links</h3>
                    <ul className="footer-links">
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/buyers">For Buyers</Link></li>
                        <li><Link to="/sellers">For Sellers</Link></li>
                        <li><Link to="/register">Register</Link></li>
                    </ul>
                </div>
                
                <div className="footer-section">
                    <h3>Legal</h3>
                    <ul className="footer-links">
                        <li><Link to="/terms">Terms of Service</Link></li>
                        <li><Link to="/privacy">Privacy Policy</Link></li>
                    </ul>
                </div>
                
                <div className="footer-section">
                    <h3>Download Our App</h3>
                    <div className="app-buttons">
                        <a href="#" className="app-button">
                            <FontAwesomeIcon icon={faApple} />
                            <span>App Store</span>
                        </a>
                        <a href="#" className="app-button">
                            <FontAwesomeIcon icon={faGooglePlay} />
                            <span>Google Play</span>
                        </a>
                    </div>
                </div>
            </div>
            
            <div className="footer-bottom">
                <div className="social-icons">
                    <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon icon={faFacebookF} />
                    </a>
                    <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon icon={faTwitter} />
                    </a>
                    <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon icon={faInstagram} />
                    </a>
                    <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon icon={faLinkedinIn} />
                    </a>
                </div>
                
                <div className="copyright">
                    <p>&copy; {currentYear} Connexierge. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer; 